import { render, staticRenderFns } from "./inbox.vue?vue&type=template&id=0dec83f9&scoped=true"
import script from "./inbox.vue?vue&type=script&lang=js"
export * from "./inbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dec83f9",
  null
  
)

export default component.exports